import React, {useEffect, useRef, useState} from 'react';
import {ChangeEventHandler} from "react";

export default function SearchInput({ onChange }: { onChange: ChangeEventHandler<HTMLInputElement>}) {
    const inputElement = useRef<HTMLInputElement>(null);
    const [localQuery, setLocalQuery] = useState('');

    useEffect(() => {
        if (inputElement.current) {
            setTimeout(() => {
                inputElement.current?.focus();

            }, 100);
        }
    }, []);


  return (
        <input
            autoFocus
            ref={inputElement}
            // @ts-ignore
            autoComplete={false}
            // @ts-ignore
            autoCorrect={false}
            className="form-control"
            placeholder="Search..."
            value={localQuery}
            onChange={(e) => {
                e.persist();
                setLocalQuery(e.target.value);
                onChange(e);
            }}
        />
    );
}
